//
//  useCsvExport.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { CsvType } from "../constants/csv";
import { getExportedCsv } from "../network/api";

const useCsvExport = (
  showMessage: (msg: string, type: "success" | "error") => void
) => {
  const handleCsvExport = async (
    csvType: CsvType,
    startDateStr: string,
    endDateStr: string,
    summaryItemIds?: string
  ): Promise<void> => {
    try {
      const response =
        csvType === "summary"
          ? await getExportedCsv(
              csvType,
              startDateStr,
              endDateStr,
              summaryItemIds
            )
          : await getExportedCsv(csvType, startDateStr, endDateStr);
      if (response.status >= 200 && response.status < 300) {
        showMessage(
          "CSV作成のリクエストを受け付けました。完了次第、作成済みCSV一覧に追加されます。",
          "success"
        );
      } else if (response.status == 404) {
        const errorMessage = response.data?.message;
        showMessage(errorMessage, "error");
      } else {
        showMessage("CSV作成の受け付けに失敗しました。", "error");
      }
    } catch (error: any) {
      console.error("CSVエクスポート中にエラーが発生しました:", error);
      const errorMessage =
        error.response?.data?.message;
      showMessage(errorMessage, "error");
    }
  };
  return { handleCsvExport };
};
export default useCsvExport;
